// @Ts-nocheck
import { FC, useContext } from 'react'
import styled from 'styled-components'

import { uploadTransformationUrl } from '@dmi-mch/utils'
import { cloudinary } from '@constants'
import { Col } from '@mch-group/uikit-components'
import { PageContext } from '@providers/PageContext'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { convertHexToRgba } from '@utils/cssHelpers'

interface IProfile {
  imageDimensions: Object,
  artistHeroImage: String,
  isArtworkData: Boolean
}
const Profile: FC<IProfile> = ({ imageDimensions, artistHeroImage, isArtworkData }) => {
  const { page: { pageData } } = useContext(PageContext)
  const { mostRelevanceArtwork } = pageData

  return (
    <Col className='col-12 col-xl-7 order-1 order-xl-2 mt-0 p-0' id='profile-image'>
      {imageDimensions &&
      <ImageWrapper
        className='position-relative d-inline-block img-wrapper'
        imgWidth={imageDimensions.width}
        imgHeight={imageDimensions.height}
      >
        <ProfileImage
          src={
            uploadTransformationUrl(artistHeroImage,`w_${imageDimensions.width},h_${imageDimensions.height},c_fit`, { 'transformUrl': cloudinary.throughCloudfront })
          }
          alt={mostRelevanceArtwork?.displayName || pageData?.name || ''}
        />
        {isArtworkData &&
          <ArtworkDetail className='position-absolute mb-3'>
            <p className='text-label-xlarge mb-0'>{mostRelevanceArtwork?.showCaption}</p>
            <p className='text-medium'>{mostRelevanceArtwork?.displayName}{`, ${mostRelevanceArtwork?.year}`}</p>
          </ArtworkDetail>
        }
      </ImageWrapper>
    }
    </Col>
  )
}

const ImageWrapper = styled.div`
  width: 100%;

  &.img-wrapper::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(360deg, ${tokens.color.light.base.neutrals[1000].value}, rgba(${convertHexToRgba(tokens.color.light.base.neutrals[900].value, tokens.opacity[0].value)}));
  }

  @media (max-width: ${global.uikitVars.breakpointSmMax}) {
    height: 468px;
  }

  @media (min-width: ${global.uikitVars.breakpointMd}) and (max-width: ${global.uikitVars.breakpointXlMax}) {
    height: 556px;
  }

  @media (min-width: ${global.uikitVars.breakpointXxl}) {
    height: 635px;
  }
`

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ArtworkDetail = styled.div`
  left: 24px;

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    left: 36px;
  }

  @media (min-width: ${global.uikitVars.breakpointLg}) {
    left: 40px;
  }

  bottom: 0;
  z-index: 9;

  p {
    color: var(--bs-mch-white);
  }
`
export default Profile
